const state = {
    isOpenCashier: true,
    cashier: {
        started: null,
        user: {
            name: ''
        },
        withdrawals: [],
        supplies: [],
        orders: []
    },
    cashiers: [],
}
const actions = {
    activeCashier: (context, pdv = null) => {
        // Corrigido para acessar o módulo correto: pos
        const pdvId = pdv || context.rootState.pos.pdv_id;
        return new Promise((resolve, reject) => {
            axios.get(`/api/cashiers/${pdvId}/active`).then(response => {
                context.commit('OPEN_CASHIER', true)
                context.commit('SHOW_CASHIER', response.data.data)
                resolve(response)
            }).catch(error => {
                context.commit('OPEN_CASHIER', false)
                reject(error)
            })
        })
    },
    showCashiers: (context) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/cashiers`).then(response => {
                context.commit('SHOW_CASHIERS', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    showCashier: (context, id) => {
        return new Promise((resolve, reject) => {
            axios.get(`/api/cashiers/${id}`).then(response => {
                context.commit('SHOW_CASHIER', response.data.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    updateCashier: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/cashiers/${payload.id}`, payload).then(response => {
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    openCashier: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.post(`/api/cashiers`, payload).then(response => {
                context.commit('OPEN_CASHIER', true)
                context.commit('STORE_CASHIER', response.data)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },
    closeCashier: (context, payload) => {
        return new Promise((resolve, reject) => {
            axios.put(`/api/cashiers/${payload.id}/close`, payload).then(response => {
                context.commit('OPEN_CASHIER', false)
                resolve(response)
            }).catch(error => {
                reject(error)
            })
        })
    },


}
const mutations = {
    OPEN_CASHIER: (state, payload) => {
        state.isOpenCashier = payload
    },

    SHOW_CASHIER: (state, payload) => {
        state.cashier = payload
    },
    SHOW_CASHIERS: (state, payload) => {
        state.cashiers = payload
    },
    STORE_CASHIER: (state, payload) => {
        state.cashier = payload
    }
}
const getters = {}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}